import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface RefreshReferenceDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  sourceTitle: string | null
  onConfirm: () => void
  pending?: boolean
}

/**
 * Confirmation dialog for "Refresh from source" — replaces the snapshot's current contents
 * (children + step_materials + step_tools beneath the Project reference) with a fresh copy
 * of the source's tree. Per UI_PLAN §4 the warning surfaces explicitly that any author edits
 * to the snapshot are lost.
 */
export const RefreshReferenceDialog = ({
  open,
  onOpenChange,
  sourceTitle,
  onConfirm,
  pending,
}: RefreshReferenceDialogProps) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Refresh from source?</AlertDialogTitle>
        <AlertDialogDescription>
          This will replace the contents of this section with the current state of
          {sourceTitle ? ` "${sourceTitle}"` : ' the source Project'}, including any edits you made
          to the snapshot here. Your changes can&apos;t be recovered.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={pending}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} disabled={pending}>
          Refresh
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
